import React from "react";
import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => (
  <section data-testid="marquee" className="border-y border-line bg-sand py-8 md:py-12">
    <Marquee speed={40} gradient={false} autoFill>
      <span className="mx-8 font-display text-6xl leading-none text-stroke md:text-8xl">
        Southern Fried Peptides
      </span>
      <span className="mx-8 font-display text-6xl leading-none text-rust md:text-8xl">•</span>
      <span className="mx-8 font-display text-6xl leading-none text-stroke md:text-8xl">
        Radiance · Recovery · Vitality
      </span>
      <span className="mx-8 font-display text-6xl leading-none text-rust md:text-8xl">•</span>
      <span className="mx-8 font-display text-6xl leading-none text-stroke md:text-8xl">
        Research Use Only
      </span>
      <span className="mx-8 font-display text-6xl leading-none text-rust md:text-8xl">•</span>
    </Marquee>
  </section>
);
